import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Price from '@bit/gerenciatd.unifiedcomponents.price';
import Slider from 'react-slick';
import Pill from '@bit/gerenciatd.unifiedcomponents.pill';
// import SvgIconLabel from "@bit/gerenciatd.unifiedicons.svg-icon-label"
import CustomLink from '@bit/gerenciatd.unifiedcomponents.custom-link';
import TextInfo from '@bit/gerenciatd.unifiedcomponents.text-info'
import SvgIconLoader from '@bit/gerenciatd.unifiedicons.svg-icon-loader';
import InfoList from '@bit/gerenciatd.unifiedcomponents.info-list';
import Arrow from '@bit/gerenciatd.unifiedcomponents.arrow';
import { CHEURON_TYPES } from '@bit/gerenciatd.unifiedicons.cheuron';
import Button from '@bit/gerenciatd.unifiedcomponents.button';
import './Comunications.scss';

export const COMPONENT_NAME = 'Comunicaciones';
class Comunications extends Component {
  state = {
    chipIndex: 0,
    icon: 0,
    page: 0,
    width: window.innerWidth,
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

updateDimensions = () => {
  this.setState({ width: window.innerWidth });
};


beforeChange = (oldIndex, newIndex) => {
  if (oldIndex !== newIndex) {
    this.setState({ page: newIndex });
  }
}

slideToPrev = () => {
  this.slider.slickPrev();
}

slideToNext = () => {
  this.slider.slickNext();
}

render() {
  const {
    page,
    width,
    chipIndex,
  } = this.state;
  const {
    components,
  } = this.props;

  const findBreak = () => {
    const widthSlider = width;
    let slides;
    let i = 0;
    let finish = false;
    while (i < settings.responsive.length && !finish) {
      if (settings.responsive[i].breakpoint <= widthSlider) {
        finish = true;
        if (i > 0) {
          slides = settings.responsive[i - 1].settings.slidesToShow;
        } else {
          slides = settings.slidesToShow;
        }
      } else {
        i++;
      }
    }
    return slides;
  }

  const originalResponsive = [
    {
      breakpoint: 1650,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1360,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 760,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ];

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: this.beforeChange,
    afterChange: this.afterChange,
    responsive: originalResponsive,
  };

  const arrowsHidden = width < 1260;
  const slides = components.options[chipIndex].icons.length;
  const leftArrowVisible = !arrowsHidden && (page > 0) && slides - findBreak() > 0;
  const rightArrowVisible = !arrowsHidden && page < slides - findBreak();
  const { chips } = components;

  return (
    <div className="Layout">
      {components['TextInfo-1'] && (
        <TextInfo {...components['TextInfo-1']} />
      )}
      { components.chips && (
        <div className="chip-container">
            {
                chips.map((chip, index) => {
                  return (
                    <div>
                      <Pill
                        onClick={() => this.setState({
                          chipIndex: index,
                          page: 0,
                        })}
                        size={{ w: 'liquid', h: 'medium' }}
                        labelSize="small"
                        label={chip.title}
                        color={chipIndex === index ? 'blue' : 'white_blue'}
                        className={chipIndex === index ? 'chip chip_choose' : 'chip'}
                        taggingInfo={{
                          componentProduct: '',
                          componentVariation: 'all',
                          componentName: COMPONENT_NAME,
                        }}
                        segment="emp"
                      />
                    </div>
                  )
                })
            }
        </div>
      )}
      <div className="comunications_container">
        <div className="comunications_container_align">
          {components.options[chipIndex]['TextInfo-1'] && (
            <TextInfo {...components.options[chipIndex]['TextInfo-1']} />
          )}
        </div>
        <div className="comunications_container_body">
          <div className="com_subtitle">
            {components.options[chipIndex]['TextInfo-2'] && (
              <TextInfo {...components.options[chipIndex]['TextInfo-2']} />
            )}
          </div>
        </div>
        <div className="icons-container">
          <div className={components.options[chipIndex].icons.length <= findBreak() ? 'scrollRoamingGapReduc' : 'scrollRoamingGap'}>
            {
                components.chips.map((chip, index) => chipIndex === index
                && (
                <Slider ref={(slider) => { this.slider = slider }} {...settings}>
                  {
                    components.options && components.options[chipIndex].icons.map((icon, index) => (
                      <div className="wrapper-icon">
                        <div
                          onKeyPress={() => { this.setState({ icon: index }) }}
                          role="button"
                          tabIndex={0}
                          className={this.state.icon === index ? 'icon-container icon-container-selected ' : 'icon-container'}
                          onClick={() => this.setState({ icon: index })}
                        >
                          <div className="icon-container_icon">
                            {icon['SvgIconLoader-1'] && (
                              <SvgIconLoader {...icon['SvgIconLoader-1']} />
                            )}
                          </div>
                          <div className="icon-container_wrapper">
                            {icon['TextInfo-1'] && (
                              <TextInfo {...icon['TextInfo-1']} />
                            )}
                            {icon['TextInfo-2'] && (
                              <TextInfo {...icon['TextInfo-2']} />
                            )}
                          </div>
                          {icon.linkItem && (
                            <CustomLink
                              taggingInfo={{
                                componentContent: `${chips[chipIndex].title}-bola-${icon['TextInfo-1'].text}`,
                                componentProduct: '',
                                componentVariation: 'all',
                                componentName: COMPONENT_NAME,
                              }}
                              link={icon.linkItem.link}
                              isBlockElement
                            />
                          )}
                        </div>
                        {
                          index + 1 < components.options[chipIndex].icons.length
                          && <div className="wrapper-dot" />
                        }
                      </div>
                    ))}
                </Slider>
                ))
            }
            <Arrow
              kind={CHEURON_TYPES.LEFT}
              onClick={leftArrowVisible ? this.slideToPrev : null}
              visible={leftArrowVisible}
              taggingInfo={{ debug: true }}
              page2go={page}
              iconProps={
                {
                  id: 'CircleCheuron',
                  kind: CHEURON_TYPES.LEFT,
                  color: 'white',
                  size: 16,
                }
              }
              size="small"
              opacity={1}
              bgColor="blue"
              margin="default"
            />
            <Arrow
              kind={CHEURON_TYPES.RIGHT}
              onClick={rightArrowVisible ? this.slideToNext : null}
              visible={rightArrowVisible}
              taggingInfo={{ debug: true }}
              page2go={page}
              iconProps={
              {
                id: 'CircleCheuron',
                kind: CHEURON_TYPES.RIGHT,
                color: 'white',
                size: 16,
              }}
              size="small"
              opacity={1}
              bgColor="blue"
              margin="default"
            />
          </div>
          {
              components.options
              && components.options[chipIndex].icons[this.state.icon].text && (
                <TextInfo
                  kind="span"
                  size="caption02"
                  text={components.options[chipIndex].icons[this.state.icon].text}
                  fontType="font-regular"
                  color="emp-dark-blue"
                  align="left"
                  className="margin-24"
                />
              )}
        </div>
        <div className="container-list">
          {components.options && components.options[chipIndex]['InfoList-1'] && (
            <InfoList direction="row" {...components.options[chipIndex]['InfoList-1']} SvgIconLoader={SvgIconLoader} />
          )}
        </div>
        {components['TextInfo-2'] && (
          <div className="bottomPrice-container">
            <TextInfo {...components['TextInfo-2']} />
            {components.options[chipIndex]['Price-1'] && (
              <Price {...components.options[chipIndex]['Price-1']} />
            )}
          </div>
        )}
        {...components.options[chipIndex]['Button-1'] && (
        <Button
          {...components.options[chipIndex]['Button-1']}
          taggingInfo={{
            componentContent: `${chips[chipIndex].title}-${components.options[chipIndex]['Button-1'].label}`,
            componentProduct: '',
            componentVariation: 'all',
            componentName: COMPONENT_NAME,
          }}
        />
        )}
      </div>
    </div>
  )
}
}

Comunications.propTypes = {
  /**
   * {
   *  "info": "Define los componentes para pintar la sección de comunicaciones
   *  "beautifulName": "components"
   * }
   */
  components: PropTypes.object.isRequired,
}

export default Comunications;
